'use strict';

import angular from 'angular';
import grid from 'angular-ui-grid';

import storage from '../storage/storage.component';

export class StorageDashboardController {

  addWindow: Function;

  data;
  model;

  storageOptions;
  storageSelected;
  storageGrid;

  /*@ngInject*/
  constructor($scope, $rootScope, Storage, WindowService, $q, AlertMessageFactory) {
    this.Storage   = Storage;
    this.scope     = $scope;
    this.Promise   = $q.defer;

    this.addWindow = WindowService.addItem;

    this.error     = AlertMessageFactory.error;
    this.success   = AlertMessageFactory.success;

    $rootScope.$on('storage.save.storage', (storage) => this.updateStorages());

    this.scope.storageForm = this.storageForm.bind(this);
  }

  $onInit() {

    this.Storage.onUpdate('storage', (storage, event) => {
      this.updateStorages();
    });

    this.data.onCategoryChange = () => this.updateStorages();

    this.storageOptions = {
      primaryKey: '_id',
      enableCellEdit: true,
      enableRowSelection: true,
      enableRowHeaderSelection: false,
      multiSelect: false,
      modifierKeysToMultiSelect: false,
      noUnselect: true,
      rowEditWaitInterval: -1,
      data: [],
      onRegisterApi: (gridApi) => {
        this.storageGrid = gridApi;

        this.storageGrid.selection.on.rowSelectionChanged(this.scope, (row) => {
          this.storageSelected = undefined;

          if(row.isSelected){
            this.storageSelected = row.entity;
          }
        });
        
        this.storageGrid.edit.on.afterCellEdit(this.scope, (rowEntity, colDef, newValue, oldValue) => {
          
          if(oldValue  == newValue) {
            return false;
          }

          return this.Storage.saveStorage(rowEntity)
            .then(() => {
              this.storageGrid.rowEdit.setRowsClean([rowEntity]);
              this.updateStorages();
            });
        });
      },
      columnDefs: [{
        displayName: '#',
        field: '_id',
        groupable: false,
        resizable: false,
        sortable: false,
        visible: false,
        width: 50
      }/*, {
        displayName: 'Категория',
        field: 'categoryId',
        groupable: true,
        resizable: true,
        sortable: true,
        visible: true,
        width: 200,
        cellTemplate: '<div class="ui-grid-cell-contents" ng-bind-html="grid.getCellValue(row, col) | renderCategory"></div>',
        editableCellTemplate: 'ui-grid/dropdownEditor',
        editDropdownValueLabel: 'name',
        //editDropdownOptionsArray: this.buildCategorOptions(this.categories),
      }*/, {
        displayName: 'Наименование',
        field: 'name',
        groupable: false,
        resizable: true,
        sortable: true,
        visible: true,
        width: 300
      }, {
        displayName: '#',
        name: ' ',
        cellTemplate: '<div><button ng-click="grid.appScope.storageForm(row.entity);$event.stopPropagation();""><i class="fa fa-pencil"></i></button></div>'
      }]
    };
  }

  buildCategorOptions(categories) {
    return categories.map(c => {
      var pad = '';
      for(var i = 0; i < c.realLelev; i++){
        pad += String.fromCharCode(160) + String.fromCharCode(160);
      }

      return {
        id: c._id,
        name: pad + c.name
      };
    });
  }

  updateStorages() {
    while(this.storageOptions.data.length > 0){
      this.storageOptions.data.shift();
    }

    this.Storage.getStorages()
      .filter(storage => (this.data.categorySelected ? this.data.categorySelected._id : undefined) == storage.categoryId)
      .forEach(storage => this.storageOptions.data.push(storage));
  }

  storageForm(storage) {
    this.addWindow({
      id: 'create-storage-window',
      component: 'storage',
      title: 'Форма редактирования',
      width: 700,
      height: 530,
      storage: storage,
      category: this.data.categorySelected,
      module: this.data.module,
    });
  }
}



export default angular.module('storageApp.storage-dashboard', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    storage,
  ])
  .component('storageDashboard', {
    bindings: {data: '='},
    template: require('./storage-dashboard.html'),
    transclude: true,
    controller: StorageDashboardController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/storage-dashboard/storage-dashboard.component.js